import React, { useState, useEffect } from 'react';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { X, CreditCard, Loader2 } from 'lucide-react';
import { Actions as PAYMENTACTIONS } from '../../store/actions/paymentActions';
import { connect } from 'react-redux';
import ACTIONS from '../../store/action';

import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';

const CARD_OPTIONS = {
  hidePostalCode: true,
  iconStyle: 'solid',
  style: {
    base: {
      iconColor: '#666',
      color: '#000',
      fontWeight: 500,
      fontFamily: 'Open Sans, Segoe UI, sans-serif',
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      display: 'flex',
      ':-webkit-autofill': { color: '#666' },
      '::placeholder': { color: '#666' },
    },
    invalid: {
      iconColor: 'red',
      color: 'red',
    },
    valid: {
      iconColor: 'green',
      color: 'green',
    },
  },
};

const AddNewCard = ({
  stripeIntent,
  getStripePaymentMethods,
  toggleAlertMessage,
  getStripeIntent,
  setAddCard,
  addCard,
  stripeCustomerId,
  createStripeCustomer,
  updateStripeCustomer,
}) => {
  const [saveCard, setSaveCard] = useState(false);
  const stripe = useStripe();
  const elements = useElements();

  useEffect(() => {
    if (stripeCustomerId.startsWith('cus')) {
      (async () => await getStripeIntent())();
    }
  }, [getStripeIntent, stripeCustomerId]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSaveCard(true);

    if (saveCard) return;

    if (!stripe || !elements) return;

    const cardElement = elements.getElement(CardElement);

    let clientSecret = stripeIntent;

    if (!stripeCustomerId.startsWith('cus')) {
      // Create a stripe customer, the true is to create an intent as well
      const response = await createStripeCustomer(true);
      const { client_secret } = response.data;
      clientSecret = client_secret;
    }

    const savedCard = await stripe.confirmCardSetup(clientSecret, { payment_method: { card: cardElement } });
    if (savedCard.error) {
      toggleAlertMessage(true, savedCard.error.message);
      setSaveCard(false);
      if (addCard) setAddCard(false);
    } else {
      if (addCard) setAddCard(false);
      setSaveCard(false);
      await updateStripeCustomer('invoice_settings', `{default_payment_method:${savedCard.setupIntent.payment_method}}`);
      await getStripePaymentMethods();
    }
  };

  return (
    <Card className='border shadow-sm bg-background'>
      <CardContent className='p-4'>
        <div className='flex flex-col sm:flex-row items-center justify-between w-full gap-4'>
          <div className='w-full sm:w-2/3'>
            <div className='bg-white p-4 rounded-md border'>
              <CardElement options={CARD_OPTIONS} />
            </div>
          </div>
          <div className='w-full sm:w-1/3 flex justify-end gap-2'>
            <Button onClick={() => setAddCard(false)} className='font-semibold' variant='outline'>
              <X size={16} strokeWidth={1.5} /> Cancel
            </Button>
            <Button
              onClick={handleSubmit}
              disabled={saveCard}
              className='font-semibold text-base bg-secondary text-secondary-foreground hover:text-primary-foreground'>
              {!saveCard ? (
                <>
                  <CreditCard size={16} strokeWidth={1.5} /> Add Card
                </>
              ) : (
                <>
                  <Loader2 size={16} strokeWidth={1.5} className='animate-spin' /> Saving Card...
                </>
              )}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

const mapStateToProps = (state) => {
  const { firstName, lastName, email } = state.profile?.details || {};
  const { vatNumber } = state.organisation?.details || {};
  const customerDetails = { name: firstName + ' ' + lastName, email, vatNumber };
  return {
    stripeIntent: state.payment?.stripe?.intent?.client_secret,
    stripeCustomerId: state.payment?.stripe?.stripeCustomerId,
    customerDetails,
    currentOrg: state.currentOrganisation,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getStripePaymentMethods: () => dispatch(PAYMENTACTIONS.getStripePaymentMethods()),
  updateStripeCustomer: (field, value) => dispatch(PAYMENTACTIONS.updateStripeCustomer(field, value)),
  getStripeIntent: () => dispatch(PAYMENTACTIONS.getStripeIntent()),
  toggleAlertMessage: (status, message) => dispatch(ACTIONS.toggleAlertMessage(status, message)),
  setStripeCustomerId: (stripeCustomerId) => dispatch(PAYMENTACTIONS.setStripeCustomerId(stripeCustomerId)),
  createStripeCustomer: (createIntent) => dispatch(PAYMENTACTIONS.createStripeCustomer(createIntent)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddNewCard);
